<template>
  <b-container fluid>
    <page-title icon="fas fa-user-tie">
      <translate>New Company</translate>
    </page-title>
    <company-form />
  </b-container>
</template>
<script>
import CompanyForm from '@/components/CompanyForm'

export default {
  name: 'RegisterPage',
  title() {
    return this.$gettext('New Company')
  },
  components: {
    CompanyForm
  }
}
</script>
